<div
  class="checkbox"
  [ngClass]="{ 'checkbox--disabled': disabled, 'checkbox--no-controls': !showControl }"
>
  <input type="checkbox" [id]="name" [disabled]="disabled" [formControl]="formEl" />
  <label [for]="name" [ngClass]="{ 'checkbox--untouched': !formEl.touched }">
    <ng-content></ng-content>
  </label>
</div>
